import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { TripEventType } from 'app/constants/delegation/tripEventType'
import {
  faFlagSolid,
  faFlagCheckeredSolid,
  faSignsPostSolid,
  faArrowRightFromLineSolid,
  faArrowRightToLineSolid,
  faCircleArrowUpSolid,
  faCircleArrowDownSolid,
  faBoxesStackedSolid,
  faDollyEmptySolid,
} from '@/lib/fa'

export const getEventTypeIcon = (
  type: TripEventType,
): IconDefinition | null => {
  switch (type) {
    case TripEventType.Begin:
      return faFlagSolid
    case TripEventType.Finish:
      return faFlagCheckeredSolid
    case TripEventType.ChangeCountry:
      return faSignsPostSolid
    case TripEventType.TripExclusionStart:
      return faArrowRightFromLineSolid
    case TripEventType.TripExclusionEnd:
      return faArrowRightToLineSolid
    case TripEventType.Arrive:
      return faCircleArrowUpSolid
    case TripEventType.Leave:
      return faCircleArrowDownSolid
    case TripEventType.Loading:
      return faBoxesStackedSolid
    case TripEventType.Unloading:
      return faDollyEmptySolid
    default:
      return null
  }
}
